module.exports = __webpack_public_path__ + "static/media/Seprator.3c6568eb.svg";